import { useGetNbaTopPlayersQuery } from "../store/api/nbaApi";

export const useNbaTopPlayers = (category = "points") => {
  const { data, isLoading, error } = useGetNbaTopPlayersQuery(category);

  return {
    topPlayers: data?.players || [],
    lastUpdated: data?.lastUpdated || null,
    isLoading,
    error,
  };
};
